// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2468":"1775b55e","4078":"c481ccaa"}[chunkId] + ".chunk.css";
};